function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.630092 0.910505L0.266253 0.547224C0.252488 0.533459 0.245605 0.516625 0.245605 0.496722C0.245605 0.476818 0.252488 0.459984 0.266253 0.446219L0.630092 0.082938C0.643857 0.0691731 0.660691 0.0622907 0.680594 0.0622907C0.700498 0.0622907 0.717332 0.0691731 0.731097 0.082938L0.772949 0.124791C0.786714 0.138556 0.793597 0.15539 0.793597 0.175293C0.793597 0.195196 0.786714 0.21203 0.772949 0.225795L0.501744 0.497001L0.772949 0.767648C0.786714 0.781785 0.793597 0.798712 0.793597 0.818429C0.793597 0.838146 0.786714 0.854887 0.772949 0.868652L0.731097 0.910505C0.717332 0.92427 0.700498 0.931152 0.680594 0.931152C0.660691 0.931152 0.643857 0.92427 0.630092 0.910505Z",
  fill: "black"
});

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0 0 1 1",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.e59ee05c.svg";
export { ForwardRef as ReactComponent };